const parseBookClubDate = (value) => {
  if (!value) {
    return null;
  }

  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatBookClubDate = (date) =>
  new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);

export const formatBookClubSchedule = (startsAt, endsAt) => {
  const start = parseBookClubDate(startsAt);
  const end = parseBookClubDate(endsAt);

  if (!start || !end) {
    return "";
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return start > today
    ? `Starting on ${formatBookClubDate(start)}`
    : `From now until ${formatBookClubDate(end)}`;
};

export const hasBookClubEnded = (endsAt) => {
  if (!endsAt) {
    return false;
  }

  const endDate = /^\d{4}-\d{2}-\d{2}$/.test(endsAt)
    ? new Date(`${endsAt}T23:59:59.999`)
    : new Date(endsAt);

  return !Number.isNaN(endDate.getTime()) && endDate.getTime() < Date.now();
};
